import mod from "-!./admin-request.js?vue&type=script&lang=js&"; export default mod; export * from "-!./admin-request.js?vue&type=script&lang=js&"